import { render } from "./DepartmentSection.vue?vue&type=template&id=a00ed678&scoped=true"
import script from "./DepartmentSection.vue?vue&type=script&lang=js"
export * from "./DepartmentSection.vue?vue&type=script&lang=js"

import "./DepartmentSection.vue?vue&type=style&index=0&id=a00ed678&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a00ed678"]])

export default __exports__